export const CONVERGENCE = {
  name: "Convergence: RL Summit",
  tagline: "Terac × SignalFire",
  dateISO: "2026-10-29T08:00:00-07:00",
  dateLong: "Thu, Oct 29, 2026",
  hours: "8:00 AM – 1:00 PM PDT",
  venue: "SVB Experience Center, San Francisco",
  venueShort: "SVB Experience Center",
  city: "San Francisco, CA",
  seats: 100,
  /** Luma holds the guest list and sends the confirmations. */
  lumaUrl: "https://luma.com/gbcompna",
} as const;

export interface AgendaItem {
  time: string;
  title: string;
  detail: string;
}

/**
 * How the day runs. The number of sessions in each block is still open, so the
 * blocks are named for the time they take rather than what fills them.
 */
export const AGENDA: readonly AgendaItem[] = [
  {
    time: "8:00 – 9:00 AM",
    title: "Doors open, coffee and breakfast networking",
    detail: "Badge pickup, coffee, and light breakfast.",
  },
  {
    time: "9:00 – 11:00 AM",
    title: "Sessions",
    detail: "Speakers and topics announced closer to the day.",
  },
  {
    time: "11:00 – 11:15 AM",
    title: "Intermission",
    detail: "Coffee and a chance to move around the room.",
  },
  {
    time: "11:15 AM – 12:30 PM",
    title: "Sessions",
    detail: "Speakers and topics announced closer to the day.",
  },
  {
    time: "12:30 – 1:00 PM",
    title: "Catered lunch",
    detail: "Lunch is provided, and the day closes at 1:00 PM.",
  },
];

export type PillarFigureName = "spiral" | "venn" | "fan";

export interface Pillar {
  title: string;
  /** Which hairline figure sits on the card's blue panel. */
  figure: PillarFigureName;
  href: string;
}

export const PILLARS: readonly Pillar[] = [
  {
    title: "Research talks, findings\n& failures",
    figure: "spiral",
    href: "#agenda",
  },
  {
    title: "Engineers, founders,\nenterprise data teams",
    figure: "venn",
    href: "#speakers",
  },
  {
    title: "Live Q&A, open panels\n& no script",
    figure: "fan",
    href: "#register",
  },
];
